import {
  getorganizeList,
  queryList,
  queryUserMenuList,
  gGroupList,
  getorganizationUser
} from '@/http/url.js'
const state = {
  userInfo: {
    fullName: '张三',
    organizationId: 10010,
    organizationName: '总公司',
    secretLevel: 10
  }, // 用户信息
  organizationId: 10010, // 部门id
  organizationids: [10010], // 部门id路径
  HomePageIds: [], //工作台页面配置
  treeData: [], // 组织机构搜索用
  organizationUserList: [], // 用户使用机构列表
  queryUserList: [], // 所有用户列表
  GroupList: [], // 所有分组列表
  queryUserMenuList: [], // 菜单栏
  formStatusList: [{ // 表单状态
    label: '待提交',
    value: '0'
  }, {
    label: '正在审批',
    value: '1'
  }, {
    label: '已归档',
    value: '2'
  }, {
    label: '退回',
    value: '3'
  },
    // {
    //     label: '取消',
    //     value: '4'
    // }
  ],
  // 花名册Excel导出头
  plainOptions: [{
    label: '序号',
    value: 'number'
  },
  {
    label: '所在部门',
    value: 'departmentName'
  },

  {
    label: '行政职务',
    value: 'position'
  },
  {
    label: '任现职务时间',
    value: 'positionTime'
  },
  {
    label: '任现职务年限',
    value: 'positionAge'
  },

  {
    label: '职级',
    value: 'positionLevel'
  },
  {
    label: '任现职级时间',
    value: 'positionLevelTime'
  },
  {
    label: '任现职级年限',
    value: 'positionLevelAge'
  },

  {
    label: '首次参加工作时间',
    value: 'firstWorkTime'
  },
  {
    label: '进入民政系统时间',
    value: 'civilOfficeSysTime'
  },
  {
    label: '进入本公司系统时间',
    value: 'headOfficeSysTime'
  },
  {
    label: '本单位工龄',
    value: 'currentOfficeSysAge'
  },
  {
    label: '总工龄',
    value: 'totalSystemAge'
  },

  {
    label: '进入本公司机关时间',
    value: 'currentOfficeSysTime'
  },
  {
    label: '首次签订合同时间',
    value: 'firstSignContractTime'
  },
  {
    label: '首次签订合同类型',
    value: 'firstContractType'
  },
  {
    label: '首次签订合同年限',
    value: 'firstContractYears'
  },
  {
    label: '首次签订到期时间',
    value: 'firstContractExpirationTime'
  },


  {
    label: '续订1合同时间',
    value: 'secondSignContractTime'
  },
  {
    label: '续订1合同类型',
    value: 'secondContractType'
  },
  {
    label: '续订1合同年限',
    value: 'secondContractYears'
  },
  {
    label: '续订1到期时间',
    value: 'secondContractExpirationTime'
  },

  {
    label: '续订2合同时间',
    value: 'thirdSignContractTime'
  },
  {
    label: '续订2合同类型',
    value: 'thirdContractType'
  },
  {
    label: '续订2合同年限',
    value: 'thirdContractYears'
  },
  {
    label: '续订2到期时间',
    value: 'thirdContractExpirationTime'
  },

  {
    label: '性别',
    value: 'sex'
  },
  {
    label: '出生年月',
    value: 'birthTime'
  },
  {
    label: '年龄',
    value: 'age'
  },
  {
    label: '民族',
    value: 'nation'
  },
  {
    label: '健康状况',
    value: 'healthStatus'
  },
  {
    label: '籍贯',
    value: 'nativePlace'
  },
  {
    label: '户口所在地',
    value: 'registeredResidence'
  },
  {
    label: '户口性质',
    value: 'registeredNature'
  },
  {
    label: '出生地',
    value: 'birthplace'
  },
  {
    label: '政治面貌',
    value: 'politicalType'
  },
  {
    label: '入党时间',
    value: 'joinPartyTime'
  },
  {
    label: '技术职称',
    value: 'technicalTitle'
  },
  {
    label: '职称聘任时间',
    value: 'appointmentTime'
  },
  {
    label: '职称获得时间',
    value: 'acquisitionTime'
  },
  {
    label: '在职教育学历',
    value: 'education'
  },
  {
    label: '在职教育学位',
    value: 'academicDegree'
  },
  {
    label: '在职教育专业',
    value: 'major'
  },
  {
    label: '在职教育毕业院校',
    value: 'graduationSchool'
  },
  {
    label: '全日制教育学历',
    value: 'firstEducation'
  },
  {
    label: '全日制教育学位',
    value: 'firstAcademicDegree'
  },
  {
    label: '全日制教育专业',
    value: 'firstMajor'
  },
  {
    label: '全日制教育毕业院校',
    value: 'firstGraduationSchool'
  },
  {
    label: '家庭地址',
    value: 'homeAddress'
  },
  {
    label: '联系电话',
    value: 'phone'
  },
  ]
}

const mutations = {
  //修改用户信息和部门id
  set_userInfo: (state, userInfo) => {
    state.userInfo = userInfo
    state.organizationId = userInfo.organizationId
    if (userInfo.homePageIds) { // 页面配置存在
      state.HomePageIds = userInfo.homePageIds.split(",")
    } else {
      state.HomePageIds = []
    }
    let organization = userInfo.organizationIdPath.split(",")
    let organizationArr = []
    organization.forEach(el => {
      organizationArr = organizationArr.concat(Number(el))
    });
    state.organizationids = organizationArr
  },
  organizeList: (state, organizeList) => {
    state.organizeList = organizeList
    state.treeData = JSON.parse(JSON.stringify(organizeList))
    state.treeData[0].disabled = true
  },
  setqueryList: (state, queryUserList) => {
    state.queryUserList = queryUserList
  },
  queryUserMenuList: (state, queryUserMenuList) => {
    state.queryUserMenuList = queryUserMenuList
  },
  setGroupList: (state, GroupList) => {
    state.GroupList = GroupList
  },
  setorganizationUserList: (state, organizationUserList) => {
    state.organizationUserList = organizationUserList
  }
}
const actions = {
  // 获取部门单位数据
  async getorganizeListFn({
    commit
  }) {
    await getorganizeList().then(res => {
      if (res.status == 200) {
        if (res.data.code == 0) {
          commit('organizeList', res.data.data)
        }
      }
    })
  },
  // 获取所有用户列表
  async getqueryUserList({
    commit
  }) {
    await queryList().then(res => {
      if (res.data.code == 0) {
        commit('setqueryList', res.data.data)
      }
    })
  },
  // 获取所有分组列表
  async getGroupList({
    commit
  }) {
    await gGroupList({
      page: 1,
      size: 500
    }).then(res => {
      if (res.data.code == 0) {
        commit('setGroupList', res.data.data)
      }
    })
  },
  // 获取动态路由
  async getqueryUserMenuList({
    commit
  }) {
    await queryUserMenuList().then((res) => {
      if (res.data.code == 0) {
        commit('queryUserMenuList', res.data.data)
      }
    })
  },
  // 获取使用机构
  async getorganizationUserList({
    commit
  }) {
    await getorganizationUser().then((res) => {
      if (res.data.code == 0) {
        commit('setorganizationUserList', res.data.data)
      }
    })
  }
}

export default {
  // namespaced: true,// 命名空间如果打开调用方式要加路径
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js